/**
 * Canonical locale codes supported by the app and marketing site. Lives in
 * the universal `shared/` bucket so the server (settings validation), the
 * web client (language selector, locale sync), and the site (language
 * toggle) all read the same object — add a locale here once and every
 * consumer picks it up.
 */

/** @type {readonly string[]} */
export const SUPPORTED_LOCALES = Object.freeze(['en', 'en-US', 'ja', 'ko', 'zh-CN', 'zh-TW']);
